export default "__VITE_ASSET__F8j7nsKB__"